import { dataService } from 'App';
import { FORM_MULTI_HEADERS_CONF, FORM_URL_ENCODED_HEADERS_CONF } from 'utils/requestHelpers';

const paramServiceUrl='/users/parameters';

export function uploadParameterFile(file) {
    let form = new FormData();
    form.append("file",file);
    return dataService.post(
      `${paramServiceUrl}`,form,FORM_MULTI_HEADERS_CONF
    );
  }